type AppLogoProps = { size?: "md" | "sm" };

export function AppLogo({ size = "md" }: AppLogoProps) {
  return (
    <img
      src="/icons/apple-touch-icon.png"
      alt="Hammie Budget"
      className={"brand-logo" + (size === "sm" ? " brand-logo-sm" : "")}
      decoding="async"
    />
  );
}

/** Logo + product line for auth pages (login, signup, password reset). */
export function AppBrandTagline() {
  return (
    <p className="brand-tagline muted">
      <AppLogo size="sm" />
      <span>
        Hammie Budget — <span className="mono">ano.bearlinesolutions.com</span>
      </span>
    </p>
  );
}
